export default {
  wrapper: { marginBottom: '12px' },
  contentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    padding: '8px 0',
    flex: '1 0 0',
    gap: 0.5,
  },
  title: {
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: 'normal',
    color: (theme) => theme.palette.reds.codingRed400,
  },
  detailsWrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 1,
    alignSelf: 'stretch',
  },
  label: {
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: 'normal',
    color: (theme) => theme.palette.grays.gray700,
  },
  value: {
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: 'normal',
    color: (theme) => theme.palette.grays.gray500,
  },
};
